"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var Button_1 = __importDefault(require("../../Button/Button"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var StyledButton = styled_components_1.default(Button_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 50px;\n  margin-left: 8px;\n"], ["\n  height: 50px;\n  margin-left: 8px;\n"])));
var TextFieldButton = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, onClick = _a.onClick, showButton = _a.showButton, buttonName = _a.buttonName, loading = _a.loading, toolTip = _a.toolTip, maxLength = _a.maxLength, primaryButton = _a.primaryButton;
    return (react_1.default.createElement(Field_1.default, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement(__1.InputField, { name: name, size: size, readOnly: readOnly, toolTip: toolTip, maxLength: maxLength }),
            showButton && (react_1.default.createElement(StyledButton, { onClick: onClick, loading: loading, name: buttonName || 'Tlacitko', primary: primaryButton }, buttonName)))));
};
TextFieldButton.defaultProps = {
    size: undefined,
    label: undefined,
    readOnly: false,
    onClick: undefined,
    showButton: false,
    buttonName: undefined,
    toolTip: undefined,
    loading: undefined,
    maxLength: undefined,
    primaryButton: undefined,
};
exports.default = TextFieldButton;
var templateObject_1;
